import Keyboard from 'simple-keyboard'
import 'simple-keyboard/build/css/index.css'

let chatHistory = []
let keyboardInstance = null
let isMinimized = false

export default function chatbot() {
    const container = document.getElementById('chatbot-container')
    const input = document.getElementById('chatbot-input')
    const sendBtn = document.getElementById('chatbot-send')
    const closeBtn = document.getElementById('chatbot-close')
    const messages = document.getElementById('chatbot-messages')
    const keyboardContainer = document.getElementById('chatbotKeyboard')
    const chatbotBox = document.getElementById('chatbot-box')
    const chatBotServerUrl = import.meta.env.VITE_API_URL

    console.log('Chatbot initializing...')

    // Container anzeigen
    if (container) {
        container.style.display = 'block'
        container.style.padding = '10px'
    }
    
    if (input) {
        input.addEventListener('input', () => {
            input.style.height = 'auto';  // zurücksetzen
            input.style.height = Math.min(input.scrollHeight, 120) + 'px'; 
        });
    }
    

    // Tastatur erstellen, falls noch nicht vorhanden
    if (!keyboardInstance && keyboardContainer) {
        try {
            keyboardContainer.innerHTML = ''
            
            keyboardInstance = new Keyboard({
                onChange: inputValue => {
                    if (input) {
                        input.value = inputValue
                    }
                },
                onKeyPress: button => {
                    if (button === "{bksp}") {
                        if (input) {
                            const current = input.value
                            input.value = current.substring(0, current.length - 1)
                            keyboardInstance.setInput(input.value)
                        }
                    } else if (button === "{enter}") {
                        sendMessage()
                    }
                },
                layout: {
                    default: [
                        '1 2 3 4 5 6 7 8 9 0',
                        'Q W E R T Z U I O P',
                        'A S D F G H J K L',
                        'Y X C V B N M',
                        '{space} {bksp} {enter}'
                    ]
                },
                display: {
                    '{bksp}': '⌫',
                    '{space}': '␣',
                    '{enter}': 'Senden'
                }
            })
            
        } catch (error) {
            console.error('Error creating keyboard:', error)
        }
    }
    
    // Fokus auf Input setzen
    if (input) {
        input.focus()
    }

    const appendMessage = (text, isUser = false) => {
        if (!messages) return
        
        const msg = document.createElement('div')
        msg.className = isUser ? 'user' : 'bot'
        msg.textContent = (isUser ? '🧍 Du: ' : '🤖 Bot: ') + text
        messages.appendChild(msg)
        messages.scrollTop = messages.scrollHeight
    }

    const sendMessage = () => {
        if (!input) return
        
        const text = input.value.trim()
        console.log('Sending message:', text)
        
        if (!text) return

        appendMessage(text, true)
        
        input.value = ''
        
        if (keyboardInstance) {
            keyboardInstance.setInput('')
        }
        if (keyboardContainer) {
            keyboardContainer.style.display = 'none'
        }

        // API Call mit verschiedenen Formaten
        fetch(chatBotServerUrl, {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ message: text })  // 💡 Nur dieses Format erlaubt
        })
        .then(res => {
            if (!res.ok) {
                throw new Error(`HTTP error! status: ${res.status}`)
            }
            return res.json()
        })
        .then(data => {
            if (data.reply) {
                appendMessage(data.reply)
            } else {
                appendMessage('Fehler: Unerwartetes Antwortformat')
            }
        })
        .catch(err => {
            appendMessage('Verbindungsfehler: ' + err.message)
        })
        
    }

    // Event-Listener für Senden-Button
    if (sendBtn) {
        sendBtn.onclick = sendMessage
    }

    // Event-Listener für Enter-Taste
    if (input) {
        input.onkeydown = (e) => { 
            if (e.key === 'Enter') {
                sendMessage()
                e.preventDefault()
            }
        }
    }
    
    // KORRIGIERT: Event-Listener für Minimieren-Button
    if (closeBtn) {
        closeBtn.onclick = () => {
            isMinimized = !isMinimized
            
            if (isMinimized) {
                // NUR die Chatbox-Inhalte ausblenden, nicht den Button selbst
                if (messages) messages.style.display = 'none'
                if (input) input.style.display = 'none'
                if (sendBtn) sendBtn.style.display = 'none'
                if (keyboardContainer) keyboardContainer.style.display = 'none'
                if (chatbotBox) chatbotBox.style.display = 'block' // Wichtig: Box bleibt sichtbar
                
                closeBtn.textContent = '+'
                
                // Button nach unten rechts positionieren für minimierten Zustand
                closeBtn.style.position = 'absolute'
                closeBtn.style.bottom = '5px'
                closeBtn.style.right = '5px'
                closeBtn.style.top = 'auto'
                
            } else {
                // Alles wieder einblenden
                if (messages) messages.style.display = 'block'
                if (input) input.style.display = 'block'
                if (sendBtn) sendBtn.style.display = 'block'
                
                closeBtn.textContent = '–'
                
                // Button-Position zurücksetzen
                closeBtn.style.position = 'absolute'
                closeBtn.style.top = '-10px'
                closeBtn.style.right = '-10px'
                closeBtn.style.bottom = 'auto'
                
                if (input) input.focus()
            }
        } 
    }
    
    // Tastatur anzeigen, wenn auf Input geklickt wird
    if (input) {
        input.onfocus = () => {
            if (!isMinimized && keyboardContainer) {
                keyboardContainer.style.display = 'block'
            }
        }
        
        input.onclick = () => {
            if (!isMinimized && keyboardContainer) {
                keyboardContainer.style.display = 'block'
            }
        }
    }
}